document.addEventListener('DOMContentLoaded', function () {
  const flipCards = document.querySelectorAll('.flip-card');

  flipCards.forEach((card) => {
    const frontFlipButton = card.querySelector('.front-flip-button');
    const backFlipButton = card.querySelector('.back-flip-button');

    frontFlipButton.addEventListener('click', function () {
      card.classList.add('flipped');
    });

    backFlipButton.addEventListener('click', function () {
      card.classList.remove('flipped');
    });
  });
});